module.exports = __webpack_public_path__ + "static/img/bi.2d210422.svg";